<template>
  <!-- Begin - Temp Help Screen Modal -->
  <v-dialog
    v-model="visible"
    max-width="500px"
    @click:outside="close()"
  >
    <v-card>
      <v-card-title class="justify-center title">
        Legend
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row dense class="justify-center grey lighten-2 black--text">
              <v-col>
                <v-chip small dense color="green darken-1" label class="text-center ma-2 white--text">FRO</v-chip>
              </v-col>
              <v-col>
                <span class="body-2">Requires an FRO or higher to release the flight.</span>
              </v-col>
          </v-row>
          <v-row dense class="justify-center grey lighten-2 black--text">
            <v-col>
              <v-chip small dense color="yellow darken-2" label class="text-center ma-2 black--text">SFRO&nbsp;</v-chip>
            </v-col>
            <v-col>
              <span class="body-2">Requires an SFRO to release, FRO's are NOT AUTHORIZED to relase this flight.</span>
            </v-col>
          </v-row>
          <v-row dense class="justify-center grey lighten-2 black--text">
            <v-col>
              <v-chip dense small color="red darken-4" label class="text-center ma-2 white--text">PAOL</v-chip>
            </v-col>
            <v-col>
              <span class="body-2">Pressure altitude is outside of limits.</span>
            </v-col>
          </v-row>
        </v-container>
        </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          color="primary"
          @click="close()"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- End - Temp Help Screen Modal -->
</template>


<script>
  export default {
    name: "Legend",
      data() {
        return {

      }
    },
    props: {
      visible: {type:Boolean, required: true}
    },
    methods:{
      close() {
        this.$emit('close');
      },
    }
  };
</script>
